export const rupiah = (n) =>
  "Rp " + Math.round(Number(n || 0)).toLocaleString("id-ID");

export const rupiahShort = (n) => {
  const v = Number(n || 0);
  if (Math.abs(v) >= 1e9) return `Rp ${(v / 1e9).toFixed(1)} M`;
  if (Math.abs(v) >= 1e6) return `Rp ${(v / 1e6).toFixed(1)} jt`;
  if (Math.abs(v) >= 1e3) return `Rp ${(v / 1e3).toFixed(0)} rb`;
  return `Rp ${v}`;
};

export const fmtDate = (s) =>
  s ? new Date(s.length === 10 ? `${s}T00:00:00+07:00` : s).toLocaleDateString("id-ID", { timeZone: "Asia/Jakarta", day: "2-digit", month: "short", year: "numeric" }) : "-";

export const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString("id-ID", { timeZone: "Asia/Jakarta", hourCycle: "h23", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(/(\d{2})\.(\d{2})$/, "$1:$2") + " WIB" : "-";
export const fmtTime = (s) => new Date(s).toLocaleTimeString("en-GB", { timeZone: "Asia/Jakarta", hourCycle: "h23", hour: "2-digit", minute: "2-digit" });

const WIB_FMT = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Jakarta", year: "numeric", month: "2-digit", day: "2-digit" });
export const dateStr = (d) => WIB_FMT.format(d);
export const todayStr = () => dateStr(new Date());
export const daysAgoStr = (n) => dateStr(new Date(Date.now() - n * 86400000));

export const onlyDigits = (s) => String(s || "").replace(/\D/g, "");

export const EMAIL_DOMAIN = "kspbam.com";
export const emailLocal = (email) => String(email || "").split("@")[0];
export const sanitizeUsername = (s) => String(s || "").toLowerCase().replace(/[^a-z0-9._-]/g, "");
export const toEmail = (u) => `${sanitizeUsername(u)}@${EMAIL_DOMAIN}`;

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  viewer: "Viewer",
  admin_wilayah: "Admin Kantor Wilayah",
  admin_cabang: "Admin Kantor Cabang",
  kepala_bagian: "Kepala Bagian",
  kasir: "Kasir",
  petugas: "Petugas Lapangan",
};

export const TX_LABELS = { setor: "Setoran", tarik: "Penarikan", pencairan: "Pencairan", angsuran: "Angsuran", potongan: "Potongan Simpanan" };
export const ROW_TONE = {
  simpanan: "[&>td:first-child]:border-l-4 [&>td:first-child]:border-l-orange-500 [&:not(tr)]:border-l-4 [&:not(tr)]:border-l-orange-500 bg-orange-500/[0.06]",
  pinjaman: "[&>td:first-child]:border-l-4 [&>td:first-child]:border-l-red-500 [&:not(tr)]:border-l-4 [&:not(tr)]:border-l-red-500 bg-red-500/[0.05]",
  angsuran: "[&>td:first-child]:border-l-4 [&>td:first-child]:border-l-green-600 [&:not(tr)]:border-l-4 [&:not(tr)]:border-l-green-600 bg-green-500/[0.06]",
};
export const txTone = (type) => (type === "angsuran" ? ROW_TONE.angsuran : type === "pencairan" ? ROW_TONE.pinjaman : ROW_TONE.simpanan);

export const MODAL_LABELS = { kasbon: "Kas Bon Diterima", setor_balik: "Setor Balik ke Kasir", pencairan: "Pencairan Pinjaman", angsuran: "Angsuran Ditagih" };

export const FREQ_UNIT = { harian: "hari", mingguan: "minggu", bulanan: "bulan" };
export const loanTenor = (l) => l.tenor ?? l.installment_count;
export const RATES = { margin: 20, admin: 7, savings: 3 };

export const LOAN_STATUS = {
  diajukan: { label: "Diajukan", cls: "bg-amber-500/15 text-amber-600 dark:text-amber-400" },
  disetujui: { label: "Disetujui", cls: "bg-sky-500/15 text-sky-600 dark:text-sky-400" },
  ditolak: { label: "Ditolak", cls: "bg-rose-500/15 text-rose-600 dark:text-rose-400" },
  berjalan: { label: "Berjalan", cls: "bg-primary/15 text-primary" },
  lunas: { label: "Lunas", cls: "bg-slate-500/15 text-slate-600 dark:text-slate-300" },
};

export const FREQ_LABELS = { harian: "Harian", mingguan: "Mingguan", bulanan: "Bulanan" };
